import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=436a18ce"
import script from "./textarea.js?vue&type=script&lang=js&external"
export * from "./textarea.js?vue&type=script&lang=js&external"
import style0 from "./textarea.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports